import { forwardRef, type InputHTMLAttributes } from "react";
import { Search } from "lucide-react";
import { cn } from "../../lib/cn";
import { fr } from "../../i18n/fr";

/**
 * SearchInput — champ de recherche laiton avec icône loupe et effacement.
 * Contrôlé : `value` + `onValueChange`.
 */

interface SearchInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "value"> {
  value: string;
  onValueChange: (v: string) => void;
  onClear?: () => void;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { value, onValueChange, onClear, className, placeholder, ...rest },
  ref,
) {
  return (
    <div className={cn("relative min-w-0", className)}>
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-parchment-200/45" />
      <input
        ref={ref}
        type="search"
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        placeholder={placeholder ?? fr.common.rechercher}
        className="h-10 w-full min-w-0 rounded border border-iron-300/50 bg-obsidian-300 pl-9 pr-9 text-sm text-parchment-100 shadow-panel-inset placeholder:text-parchment-200/35 transition-all duration-200 ease-brass focus:border-arcane-300/70 focus:shadow-glow-arcane focus:outline-none"
        {...rest}
      />
      {value && (
        <button
          type="button"
          onClick={() => {
            onValueChange("");
            onClear?.();
          }}
          aria-label={fr.common.fermer}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-parchment-200/40 hover:text-parchment-100"
        >
          ✕
        </button>
      )}
    </div>
  );
});
